import { Component, LOCALE_ID, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ScheduleService } from './schedule.service';
import { ScheduleModel } from './schedule.model';
import { NewEventDialogComponent } from './new-event-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DummyComponent } from '../../shared/dummy.component';
import { ConceptModel } from '../concept/concept/concept.model';
import { ConceptService } from '../concept/concept/concept.service';
import { ContactModel } from '../contact/contact/contact.model';
import { ContactService } from '../contact/contact/contact.service';
import { CalendarEvent, CalendarEventTimesChangedEvent, CalendarView } from 'angular-calendar';
import { addDays, addMonths, endOfWeek, format, startOfWeek } from 'date-fns';
import { es } from 'date-fns/locale';
import { CalendarDateFormatter, DateFormatterParams } from 'angular-calendar';
import { Injectable } from '@angular/core';
import { formatDate } from '@angular/common';
import { ScheduleDetailsDialogComponent } from './schedule-details-dialog.component';
import { CustomDateFormatter } from '../../shared/customs/custom-date-formatter';
import { MasterService } from '../../modules_v2/master/services/master.service';

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.css'],
    providers: [
        { provide: LOCALE_ID, useValue: 'es' }, // 👈 idioma español
        { provide: CalendarDateFormatter, useClass: CustomDateFormatter } // 👈 solo este componente
    ],
    standalone: false
})
export class CalendarComponent implements OnInit {

    CalendarView = CalendarView;

    view: CalendarView = CalendarView.Week;
    viewDate: Date = new Date();


    selectedMonth = this.viewDate.getMonth();
    selectedYear = this.viewDate.getFullYear();

    months = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];

    years = Array.from({ length: 10 }, (_, i) => this.selectedYear - 5 + i); // ej. 2020–2029

    events: CalendarEvent[] = [
    ];

    eventsDtos = [];

    setView(view: CalendarView) {
        this.view = view;
    }

    /** 🔹 Título dinámico según la vista */
    get viewTitle(): string {
        if (this.view === CalendarView.Month) {
            return format(this.viewDate, "MMMM yyyy", { locale: es });
        }
        if (this.view === CalendarView.Week) {
            const start = startOfWeek(this.viewDate, { weekStartsOn: 1 });
            const end = endOfWeek(this.viewDate, { weekStartsOn: 1 });
            return `Semana del ${format(start, "d 'al' ", { locale: es })}${format(end, "d 'de' MMMM yyyy", { locale: es })}`;
        }
        if (this.view === CalendarView.Day) {
            return format(this.viewDate, "EEEE d 'de' MMMM yyyy", { locale: es });
        }
        return '';
    }

    previous(): void {
        if (this.view === CalendarView.Month) {
            this.viewDate = addMonths(this.viewDate, -1);
        } else {
            this.viewDate = addDays(this.viewDate, this.view === CalendarView.Week ? -7 : -1);
        }
        this.syncSelectors();
    }

    next(): void {
        if (this.view === CalendarView.Month) {
            this.viewDate = addMonths(this.viewDate, 1);
        } else {
            this.viewDate = addDays(this.viewDate, this.view === CalendarView.Week ? 7 : 1);
        }
        this.syncSelectors();
    }

    today(): void {
        this.viewDate = new Date();
        this.syncSelectors();
    }

    changeMonth(): void {
        const newDate = new Date(this.viewDate);
        newDate.setMonth(this.selectedMonth);
        this.viewDate = newDate;
    }

    changeYear(): void {
        const newDate = new Date(this.viewDate);
        newDate.setFullYear(this.selectedYear);
        this.viewDate = newDate;
    }

    private syncSelectors(): void {
        this.selectedMonth = this.viewDate.getMonth();
        this.selectedYear = this.viewDate.getFullYear();
    }

    newEvent: ScheduleModel = {
        id: 0,
        activityId: 0,
        title: '',
        contactUid: '',
        conceptUid: '',
        description: '',
        observations: '',
        startDate: '',
        endDate: '',
        isAllDay: false,
        createdAt: '',
    };

    blockedDays: string[] = []; // Festivos en formato YYYY-MM-DD

    constructor(
        private http: HttpClient,
        private scheduleService: ScheduleService,
        private router: Router,
        public dialog: MatDialog,
        private masterService: MasterService,
        private contactService: ContactService,
        private conceptService: ConceptService,
        private dummy: DummyComponent
    ) { }

    contacts: any[] = [];
    concepts: any[] = [];
    working = true;

    ngOnInit(): void {

        this.masterService.getContacts().subscribe(response => {
            this.contacts = response.map(item => ({
                uid: item.id,
                companyName: item.display
            }));
        });

        this.masterService.getConcepts().subscribe(response => {
             this.concepts = response.map(item => ({
                uid: item.id,
                name: item.display
            }));
        });

        // this.contactService.getList().then(response => {
        //     this.contacts = response.list;
        //     this.conceptService.getList().then(response => {
        //         this.concepts = response;
        //         this.working = false;
        //         // this.blockedDays = this.getSpanishHolidays(new Date().getFullYear());
        //     });
        // });

        this.update();
    }

    update() {
        this.scheduleService.getCalendarEvents().subscribe(events => {
            this.events = events.map(e => ({
                id: e.id,
                title: e.title,
                draggable: true,
                resizable: {
                    beforeStart: true,
                    afterEnd: true
                },
                start: new Date(e.start),
                end: new Date(e.end),
                meta: { id: e.id, contactName: e.contactName, data: e }
            }));
        });
    }

    onEventClicked({ event }: { event: CalendarEvent }): void {
        let schedule = new ScheduleModel();
        this.scheduleService.getById(event.meta.id).subscribe(response => {
            schedule = response;
            this.dialog.open(ScheduleDetailsDialogComponent, {
                data: {
                    newEvent: schedule,
                    contacts: this.contacts
                }
            }).afterClosed().subscribe(result => {
                this.update();
            })
        });
    }

    onHourClicked({ date }: { date: Date }): void {
        const start = new Date(date);
        const end = new Date(start.getTime() + 60 * 60 * 1000);

        this.prepareNewEvent(start, end);
        this.createEvent();
    }

    onDayClicked({ date }: { date: Date }): void {
        // Si haces clic en el mes, podemos iniciar el evento en esa fecha a las 09:00 por ejemplo
        const start = new Date(date);
        start.setHours(9, 0, 0);
        const end = new Date(start.getTime() + 60 * 60 * 1000);

        this.prepareNewEvent(start, end);
        this.createEvent();
    }

    /** 🔧 Método común para formatear y preparar la estructura */
    private prepareNewEvent(start: Date, end: Date): void {
        const formatDateTime = (d: Date) => {
            const year = d.getFullYear();
            const month = ('0' + (d.getMonth() + 1)).slice(-2);
            const day = ('0' + d.getDate()).slice(-2);
            const hours = ('0' + d.getHours()).slice(-2);
            const minutes = ('0' + d.getMinutes()).slice(-2);
            return `${year}-${month}-${day}T${hours}:${minutes}`;
        };

        this.newEvent.startDate = formatDateTime(start);
        this.newEvent.endDate = formatDateTime(end);
    }


    // onEventClicked(dateStr: string) {
    //     const selectedDate = new Date(dateStr);
    //     const now = new Date();
    //     const start = new Date(
    //         selectedDate.getFullYear(),
    //         selectedDate.getMonth(),
    //         selectedDate.getDate(),
    //         now.getHours(),
    //         now.getMinutes()
    //     );

    //     const end = new Date(start.getTime() + 60 * 60 * 1000);
    //     const formatDateTime = (d: Date) => {
    //         const year = d.getFullYear();
    //         const month = ('0' + (d.getMonth() + 1)).slice(-2);
    //         const day = ('0' + d.getDate()).slice(-2);
    //         const hours = ('0' + d.getHours()).slice(-2);
    //         const minutes = ('0' + d.getMinutes()).slice(-2);
    //         return `${year}-${month}-${day}T${hours}:${minutes}`;
    //     };

    //     this.newEvent.startDate = formatDateTime(start);
    //     this.newEvent.endDate = formatDateTime(end);
    //     this.createEvent();
    // }

    createEvent() {
        this.newEvent.createdAt = new Date().toISOString();
        this.newEvent.description = '';
        this.newEvent.title = '';
        this.newEvent.observations = '';

        this.dialog.open(NewEventDialogComponent, {
            width: '800px',
            data: { newEvent: this.newEvent, contacts: this.contacts, concepts: this.concepts }
        }).afterClosed().subscribe(() => this.update());
    }

    /**
     * Devuelve un array de días festivos de España para un año determinado en formato YYYY-MM-DD
     * Solo festivos nacionales y Semana Santa; fines de semana no bloqueados.
     */
    // private getSpanishHolidays(year: number): string[] {
    //     const pad = (n: number) => n.toString().padStart(2, '0');
    //     const format = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

    //     const holidays: string[] = [];

    //     // Festivos fijos nacionales
    //     holidays.push(format(new Date(year, 0, 1)));   // Año Nuevo
    //     holidays.push(format(new Date(year, 0, 6)));   // Reyes
    //     holidays.push(format(new Date(year, 4, 1)));   // Día del Trabajo
    //     holidays.push(format(new Date(year, 7, 15)));  // Asunción
    //     holidays.push(format(new Date(year, 9, 12)));  // Fiesta Nacional
    //     holidays.push(format(new Date(year, 10, 1)));  // Todos los Santos
    //     holidays.push(format(new Date(year, 11, 6)));  // Constitución
    //     holidays.push(format(new Date(year, 11, 8)));  // Inmaculada Concepción
    //     holidays.push(format(new Date(year, 11, 25))); // Navidad

    //     // Festivos variables (Semana Santa)
    //     const easterSunday = this.calculateEasterSunday(year);
    //     const goodFriday = new Date(easterSunday); goodFriday.setDate(easterSunday.getDate() - 2);
    //     const easterMonday = new Date(easterSunday); easterMonday.setDate(easterSunday.getDate() + 1);
    //     holidays.push(format(goodFriday));
    //     holidays.push(format(easterMonday));

    //     return holidays;
    // }

    /**
     * Algoritmo para calcular Domingo de Pascua
     */
    private calculateEasterSunday(year: number): Date {
        const f = Math.floor,
            G = year % 19,
            C = f(year / 100),
            H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
            I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
            J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
            L = I - J,
            month = 3 + f((L + 40) / 44),
            day = L + 28 - 31 * f(month / 4);
        return new Date(year, month - 1, day);
    }

    onEventTimesChanged({ event, newStart, newEnd }: CalendarEventTimesChangedEvent): void {
        // Actualizamos las fechas en el array local
        this.events = this.events.map(iEvent => {
            if (iEvent === event) {
                return {
                    ...event,
                    start: newStart,
                    end: newEnd
                };
            }
            return iEvent;
        });

        const eventDto = event.meta.data;

        eventDto.startDate = new Date(newStart);
        eventDto.endDate = new Date(newEnd);


        // (Opcional) Guardar cambios en backend
        this.scheduleService.update(eventDto).subscribe(resp => {
            this.events = this.events.map(iEvent => {
                if (iEvent === event) {
                    return {
                        ...event,
                        start: newStart,
                        end: newEnd
                    };
                }
                return iEvent;
            });
        });
    }



  public trackByIndex(i: number) { return i; }

}


